/**
 * 학부모 노출 문자열 — 명세서 §13.1 불변 규칙 ③
 *
 * "학부모 노출 문자열은 packages/shared의 카피 상수를 사용한다."
 * 화면에 직접 한글 리터럴을 박지 말고 이 파일을 통해 쓴다.
 * 톤: 미니멀·다정함(§7.1). 결핍 언어 금지(§6.9).
 */
export const BRAND = {
    name: '새싹돋보기',
    tagline: '새싹이 돋아나는 것을 보다',
    description: '아이의 하루와 성장을 따뜻하게 주고받는 곳',
};
/** 발달 화면 상시 노출 문구 — §6.1-3 자기 비교 원칙 */
export const DEVELOPMENT_COPY = {
    everyChildOwnPace: '모든 아이는 자기 속도로 자랍니다',
    tabName: '돋보기',
    treeTitle: '우리 아이 새싹 나무',
    noComparisonNotice: '또래와 비교하지 않고, 아이 자신의 시간 축으로만 보여드려요.',
    evidenceHint: '선생님이 관찰한 순간과 사진이 함께 담겨요.',
    emptyTitle: '아직 기록이 도착하지 않았어요',
    emptyBody: '선생님이 이번 구간을 관찰하고 있어요. 기록이 준비되면 알려드릴게요.',
    /**
     * @param childName 원아 이름
     * @param itemText 관찰 항목
     * @param stageName 단계 표시명
     */
    stageSentence: (childName, itemText, stageName) => `${childName}이는 '${itemText}'에서 ${stageName} 단계를 지나고 있어요.`,
    periodTaskSentence: (childName, periodLabel) => `${childName}이의 ${periodLabel} 기록을 시작할 수 있어요`,
};
/** 빈 화면은 안내가 아닌 행동 유도로 — §7.5 */
export const EMPTY_STATES = {
    dailyNoteParent: {
        title: '아직 오늘의 알림장이 없어요',
        body: '선생님이 하루를 정리하는 중이에요.',
    },
    dailyNoteTeacher: {
        title: '아직 알림장이 없어요',
        body: '오늘 우리 반의 하루를 남겨 볼까요?',
        action: '첫 알림장 쓰기',
    },
    notice: {
        title: '새 공지가 없어요',
        body: '원에서 소식이 오면 여기에 모아 드릴게요.',
    },
    album: {
        title: '아직 사진이 없어요',
        body: '새로운 활동 사진이 올라오면 알려드릴게요.',
    },
    notification: {
        title: '새 알림이 없어요',
        body: '중요한 소식은 여기에서 모아 볼 수 있어요.',
    },
    attendance: {
        title: '오늘 출석 기록이 아직 없어요',
        body: '등원하면 바로 알려드릴게요.',
    },
    children: {
        title: '연결된 아이가 없어요',
        body: '원에서 받은 초대코드를 입력하면 연결돼요.',
        action: '초대코드 입력하기',
    },
    lifeRecord: {
        title: '아직 발급된 생활기록부가 없어요',
        body: '원에서 발급하면 여기에서 확인하고 저장할 수 있어요.',
    },
    schedule: {
        title: '예정된 일정이 없어요',
        body: '행사나 준비물이 생기면 미리 알려드릴게요.',
    },
    meal: {
        title: '이번 주 식단이 아직 올라오지 않았어요',
        body: '준비되면 알레르기 정보와 함께 보여드릴게요.',
    },
    medication: {
        title: '투약 의뢰가 없어요',
        body: '약을 맡기실 때 여기에서 의뢰서를 작성할 수 있어요.',
        action: '투약의뢰서 쓰기',
    },
    pickup: {
        title: '등록된 하원 담당자가 없어요',
        body: '평소 아이를 데리러 오시는 분을 미리 등록해 두면 안심이에요.',
        action: '하원 담당자 등록',
    },
    growth: {
        title: '아직 키·몸무게 기록이 없어요',
        body: '원에서 계측하면 자라온 흐름을 그려 드릴게요.',
    },
    counseling: {
        title: '신청한 면담이 없어요',
        body: '아이에 대해 나누고 싶은 이야기가 있으면 편하게 신청해 보세요.',
        action: '면담 신청하기',
    },
    message: {
        title: '주고받은 쪽지가 없어요',
        body: '아이에 대한 이야기를 선생님과 1:1로 나눌 수 있어요.',
    },
    consent: {
        title: '요청받은 동의서가 없어요',
        body: '원에서 동의서를 보내면 여기에서 바로 응답할 수 있어요.',
    },
};
/** 원 소개 (§5.26) — 학부모 노출 카피 */
export const INTRO_COPY = {
    title: '원 소개',
    mottoLabel: '원훈',
    greetingLabel: '인사말',
    symbolsLabel: '원의 상징',
    songLabel: '원가',
    emptyTitle: '소개를 준비하고 있어요',
    emptyBody: '원에서 소개를 채우면 여기에서 볼 수 있어요.',
};
/** 오늘의 급식 사진 (§5.7) */
export const MEAL_PHOTO_COPY = {
    title: '오늘의 급식 사진',
    empty: '오늘 급식 사진이 올라오면 여기에서 볼 수 있어요.',
};
/** 버스 실시간 위치 (§5.20 P6) — 학부모 노출 카피 */
export const BUS_LIVE_COPY = {
    title: '버스',
    emptyTitle: '배정된 버스 노선이 없어요',
    emptyBody: '원에서 아이를 버스 노선에 배정하면 여기에서 볼 수 있어요.',
    notStarted: '아직 운행 전이에요',
    running: '운행 중',
    ended: '오늘 운행이 끝났어요',
    noSignalYet: '기사님 위치가 아직 잡히지 않았어요. 잠시만 기다려 주세요.',
    mapUnavailable: '지도는 준비 중이에요. 정거장 순서와 도착 임박 알림은 그대로 받아요.',
    approachNote: '정거장 가까이 오면 도착 임박 알림을 보내 드려요.',
    /** 진행 안내 — "몇 정거장 전" 배너 (§5.20 P6) */
    nextStopPrefix: '다음 정거장',
    approachingMine: '다음이 우리 아이 정거장이에요!',
    stopsAwaySuffix: '개 정거장 전이에요',
    stopsAwayPrefix: '우리 아이 정거장까지 ',
    minePassed: '우리 아이 정거장을 지나갔어요',
    passedMark: '지남',
    nextMark: '다음',
};
/** 범용 전자동의서 (P5) — 학부모 노출 카피. 사진 공개 동의 카피는 CONSENT_COPY. */
export const CONSENT_FORM_COPY = {
    agree: '동의해요',
    decline: '동의하지 않아요',
    agreedChip: '동의함',
    declinedChip: '동의 안 함',
    pendingChip: '응답 대기',
    signedNote: (when) => `${when}에 응답했어요.`,
    commentPlaceholder: '전하고 싶은 말이 있으면 함께 남겨 주세요. (선택)',
    legalNote: '버튼을 누르면 전자 서명으로 기록돼요. 응답 후에는 원에 문의해 변경할 수 있어요.',
};
/** AI 육아상담 챗봇 (§5.16) — P4 */
export const CHAT_COPY = {
    /** 응급 징후 감지 시 모델 호출 없이 먼저 내는 고정 응답 (§5.16 가드레일) */
    emergency: '지금 말씀하신 증상은 바로 진료가 필요할 수 있어요.\n\n즉시 119에 전화하시거나 가까운 응급실로 가 주세요. 아이 상태를 계속 지켜보면서, 의식·호흡에 변화가 있으면 그 내용을 의료진에게 알려 주세요.\n\n이 상담은 의료 진단을 대신할 수 없어요.',
    disclaimer: '육아 정보 안내일 뿐 의료 진단이 아니에요. 아프면 소아과 진료를 먼저 받아 주세요.',
    limitReached: (limit) => `오늘 질문 한도(${limit}회)를 모두 썼어요. 내일 다시 물어볼 수 있어요.`,
    placeholder: '궁금한 것을 물어보세요',
    emptyTitle: '무엇이든 물어보세요',
    emptyBody: '수유·이유식, 수면, 배변훈련, 말놀이 같은 육아 이야기를 아이 월령에 맞춰 안내해 드려요.',
};
/** 추천 질문 칩 (§5.16) */
export const CHAT_SUGGESTED_QUESTIONS = [
    '이유식을 잘 안 먹으면 어떻게 하나요?',
    '밤에 자주 깨요. 수면 습관을 어떻게 잡죠?',
    '배변훈련은 언제 시작하면 좋아요?',
    '말이 트이게 도와주는 놀이가 있을까요?',
    '떼쓰기가 심할 때 어떻게 반응해야 하나요?',
    '친구를 깨물거나 밀어요. 어떻게 알려 주죠?',
];
/** 쪽지 (§5.18) — P4 */
export const MESSAGE_COPY = {
    afterHours: (start, end) => `지금은 응대 시간(평일 ${start}–${end})이 아니에요. 선생님이 다음 근무시간에 확인하고 답장드릴게요.`,
    placeholder: '전하고 싶은 이야기를 남겨 주세요.',
};
/** 부모면담 (§5.15) — P4 */
export const COUNSELING_COPY = {
    requested: '면담을 신청했어요. 선생님이 일정을 확인하면 알려드릴게요.',
    confirmed: (when) => `${when}에 면담이 확정됐어요.`,
    summaryLabel: '면담 이야기',
    summaryNotice: '면담에서 나눈 이야기를 선생님이 정리해 드린 내용이에요.',
    canceled: '면담 신청을 취소했어요.',
};
/** 일상 기능 (§5.5~§5.11) — P2 */
export const DAILY_LIFE_COPY = {
    album: {
        consentWarning: (names) => `${names.join(', ')} 보호자께서 사진 공개에 아직 동의하지 않으셨어요. 이 사진은 해당 가정에만 보이지 않게 처리돼요.`,
        parentScopeNotice: '우리 아이가 담긴 사진과 영상만 모아서 보여드려요.',
        videoBadge: '영상',
        /** 카드 아래 개수 — 영상이 있을 때만 따로 센다 (v1.22) */
        mediaCount: (photos, videos) => videos > 0 ? `사진 ${photos}장 · 영상 ${videos}개` : `사진 ${photos}장`,
        videoUploading: '영상을 올리는 중이에요. 크기에 따라 시간이 걸릴 수 있어요.',
        filteredEmpty: (name) => `아직 ${name}(이)가 담긴 앨범이 없어요. 새 사진이 올라오면 여기에 모여요.`,
    },
    schedule: {
        suppliesReminder: (title, supplies) => `내일은 '${title}'이 있어요. ${supplies} 챙겨 주세요.`,
        suppliesLabel: '준비물',
    },
    meal: {
        allergyNotice: (allergens) => `${allergens.join(', ')}이(가) 들어 있어요. 선생님이 함께 살펴볼게요.`,
        allergyBadge: '알레르기 확인',
        servedPhotoLabel: '실제 배식 사진',
    },
    medication: {
        signatureHint: '칸 안에 손가락으로 서명해 주세요.',
        submitted: '투약의뢰서를 전달했어요. 선생님이 확인하면 알려드릴게요.',
        administered: (childName, at) => `${childName}이의 약을 ${at}에 먹였어요.`,
        consentNotice: '투약은 의뢰서에 적어 주신 대로만 진행해요.',
    },
    pickup: {
        defaultBadge: '평소 담당',
        changeRequested: '오늘 하원 담당자 변경을 요청했어요. 선생님이 확인하면 알려드릴게요.',
        changeConfirmed: (name) => `오늘은 ${name}께서 데리러 오시는 것으로 확인했어요.`,
        safetyNotice: '안전을 위해 선생님이 확인한 뒤에 하원할 수 있어요.',
        locationConsentBadge: '위치 공유 동의',
    },
    health: {
        temperatureNotice: (temperature) => `체온이 ${temperature}℃로 확인됐어요. 선생님이 계속 살펴보고 있어요.`,
        /**
         * 참조선을 그리게 되면서 문구도 바꿨다(§5.11). 또래 분포를 배경으로 보여주되,
         * 위치가 아니라 **흐름**을 보시라고 안내한다 — §6.1-3 자기 비교 원칙의 취지를 지킨다.
         */
        growthNotice: '연한 선은 또래 아이들의 분포예요. 선 위아래보다 우리 아이가 자라온 흐름을 봐 주세요.',
        referenceEdition: (label, nextYear) => `${label} 기준이에요. 다음 개정은 ${nextYear}년 예정입니다.`,
        percentileLabel: (percentile) => `또래 분포에서 약 ${Math.round(percentile)}번째 자리`,
        noReference: '이 나이는 참조 자료 범위 밖이라 선을 그리지 않았어요.',
        sexUnknown: '성별이 등록되지 않아 참조선을 그릴 수 없어요.',
    },
};
export const HOME_COPY = {
    parentTitle: '오늘의 우리 아이',
    teacherTitle: '우리 반 오늘',
    greetingMorning: '좋은 아침이에요',
    greetingAfternoon: '오늘 하루도 수고 많으셨어요',
    greetingEvening: '편안한 저녁 되세요',
    todoTitle: '해야 할 일',
    todoEmpty: '오늘은 확인할 일이 없어요',
};
/** 원아 기본 정보 (§5.2 v1.22 주소) — 프로필·등록 화면 */
export const CHILD_COPY = {
    addressLabel: '주소',
    addressPlaceholder: '예: 대구 수성구 달구벌대로 2000, 101동 1001호',
    addressHint: '비상 시 연락과 등하원 안내에 쓰여요. 원과 보호자가 함께 고칠 수 있어요.',
    addressEmpty: '아직 주소가 없어요.',
    emergencyLabel: '비상연락',
    registerTitle: '원아 등록',
    registered: (name) => `${name} 어린이를 등록했어요. 보호자 초대코드를 보내 주세요.`,
};
export const ATTENDANCE_COPY = {
    checkedIn: '등원했어요',
    checkedOut: '하원했어요',
    absent: '결석',
    late: '지각',
    earlyLeave: '조퇴',
    notYet: '아직 등원 전이에요',
};
export const CONSENT_COPY = {
    photoTitle: '사진 공개 동의',
    photoBody: '동의하지 않으면 아이가 태그된 사진은 다른 가정에 보이지 않아요. 언제든지 바꿀 수 있어요.',
    downloadBlocked: '원본 저장은 아이들의 초상권 보호를 위해 잠겨 있어요.',
};
export const SUBSCRIPTION_COPY = {
    trialBanner: (daysLeft) => `체험 기간이 ${daysLeft}일 남았어요`,
    graceBanner: '구독이 만료되어 지금은 읽기 전용이에요. 기존 기록은 계속 보실 수 있어요.',
    expiredBanner: '새 기록 작성은 잠시 멈춰 있어요. 기존 기록 열람은 계속 가능합니다.',
    readOnlyAction: '지금은 새로 작성할 수 없어요',
};
export const AI_COPY = {
    draftNotice: '관찰하신 내용만을 근거로 초안을 만들었어요. 확인하고 다듬어 주세요.',
    reviewRequired: '초안은 선생님이 확인한 뒤에 저장돼요.',
    noEvidenceWarning: '입력하지 않은 행동은 초안에 들어가지 않아요.',
    chatDisclaimer: '이 상담은 일반적인 육아 정보 안내예요. 진단·처방이 필요할 땐 소아과 진료를 받아 주세요.',
    chatEmergency: '지금 상황은 바로 도움이 필요할 수 있어요. 119 또는 가까운 응급실로 연락해 주세요.',
};
export const ERROR_COPY = {
    network: '연결이 잠시 불안정해요. 다시 시도해 주세요.',
    unauthorized: '다시 로그인해 주세요.',
    forbidden: '이 화면을 볼 수 있는 권한이 없어요.',
    notFound: '찾는 내용이 없어요.',
    unknown: '문제가 생겼어요. 잠시 후 다시 시도해 주세요.',
};
/** 앱 설정 채널 (v1.18) — 설정 허브·건의함·업로드·번역·정책·도움말 */
export const SETTINGS_COPY = {
    title: '앱 설정',
    groupUser: '사용자 설정',
    groupService: '서비스 이용',
    groupEtc: '기타',
    uploads: '사진 업로드 설정',
    translation: '번역 기능 설정',
    blocks: '차단한 사용자',
    feedback: '불편·제안 보내기',
    help: '도움말',
    policies: '약관 및 처리방침',
    versionLabel: '현재 버전',
    accountDelete: '계정 탈퇴',
};
/** 계정 탈퇴 (§5.1, §14.1 스토어 요건) — 화면·공개 안내 페이지가 함께 쓴다 */
export const ACCOUNT_DELETE_COPY = {
    title: '계정 탈퇴',
    intro: '탈퇴하면 되돌릴 수 없어요. 아래 내용을 확인해 주세요.',
    removedTitle: '즉시 삭제·익명화되는 것',
    removedItems: [
        '이름·이메일·전화번호·프로필 사진 등 계정의 개인정보',
        '본인확인 정보(CI)와 카카오 계정 연결',
        '알림 수신 설정과 이 기기의 로그인',
        '자녀와의 열람 연결 (앱에서 더 이상 아이 기록을 볼 수 없어요)',
    ],
    keptTitle: '기관에 남는 것',
    keptItems: [
        '어린이집·유치원이 작성 주체인 원아 기록(알림장·발달기록·생활기록부·서류)은 아동 기록 보호를 위해 기관 소유로 보존돼요.',
        '탈퇴 후 다시 이용하려면 기관의 초대코드로 새로 가입하면 돼요.',
    ],
    directorNote: '원장 계정은 다른 원장에게 운영권을 넘긴 뒤 탈퇴할 수 있어요.',
    confirmPhrase: '탈퇴합니다',
    confirmGuide: '계속하려면 아래 칸에 "탈퇴합니다"를 입력해 주세요.',
    submit: '계정 탈퇴하기',
    done: '탈퇴가 완료됐어요. 그동안 함께해 주셔서 고마워요.',
    webGuideTitle: '새싹돋보기 계정 삭제 안내',
    webGuideSteps: [
        '앱(또는 saesak.kr) 로그인 → 전체 메뉴 → 이용 안내 → 앱 설정',
        '"계정 탈퇴"를 열어 안내를 확인하고 확인 문구를 입력하면 즉시 처리돼요',
    ],
    webGuideAlt: '로그인할 수 없는 경우, 가입한 이메일로 고객센터에 삭제를 요청하면 본인 확인 후 처리해 드려요.',
};
export const UPLOAD_SETTINGS_COPY = {
    wifiTitle: 'Wi-Fi 연결 확인',
    wifiSub: '데이터로 올릴 때 한 번 물어봐요',
    wifiNotice: 'Wi-Fi 연결 확인을 꺼두시면 이동통신 데이터에서도 바로 업로드돼요. 요금제에 따라 데이터 사용량이 커질 수 있어 켜두시는 것을 권해요.',
    wifiConfirm: 'Wi-Fi가 아닌 데이터 연결이에요. 지금 올릴까요?',
    qualityTitle: '사진 크기 (업로드)',
    qualityNotice: "'원본 화질'을 선택하면 용량이 큰 사진을 올릴 때 데이터 사용량이 커질 수 있어요. 화면에서 보기에는 권장 화질로 충분해요.",
};
export const FEEDBACK_COPY = {
    title: '불편·제안 보내기',
    intro: '쓰다가 불편했던 점, 있으면 좋겠는 기능을 들려주세요. 보내주신 목소리는 매일 아침 운영진이 함께 읽어요.',
    placeholder: '어떤 점이 불편했는지, 어떤 기능이 있으면 좋을지 편하게 적어 주세요.',
    submit: '보내기',
    doneTitle: '잘 전해드렸어요',
    doneBody: '소중한 의견 고마워요. 운영진이 매일 아침 함께 읽고 하나씩 반영해 갈게요.',
    another: '하나 더 보내기',
};
export const TRANSLATE_COPY = {
    title: '번역 기능 설정',
    toggleTitle: '번역 기능',
    notice: '번역 기능은 다문화가정과 원의 원활한 소통을 위해 제공해요. AI 번역이라 일부 표현은 의미가 조금 다르게 전달될 수 있어요.',
    langLabel: '번역할 언어',
    showButton: '번역 보기',
    hideButton: '번역 접기',
    loading: '번역하는 중이에요',
    caution: 'AI 번역이에요. 중요한 내용은 선생님께 꼭 확인해 주세요.',
    unavailable: '지금은 번역 기능이 준비 중이에요.',
};
export const POLICIES_COPY = {
    title: '약관 및 처리방침',
    terms: '서비스 이용약관',
    privacy: '개인정보 처리방침',
    pricing: '요금 및 환불 안내',
};
export const HELP_COPY = {
    title: '도움말',
    intro: '자주 묻는 질문을 모았어요. 더 궁금한 점은 불편·제안 보내기로 들려주세요.',
};
//# sourceMappingURL=copy.js.map